import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface DialogData {
    message: string;
    options: any;
}

@Component({
    selector: 'app-popdiag',
    styleUrls: ['./dialog-pop.component.scss'],
    templateUrl: './dialog-pop.component.html',
    standalone: false
})
export class DialogPopComponent {
    constructor(public dialogRef: MatDialogRef<DialogPopComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
